// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__103ut","userIcon":"styles_userIcon__1qGgB","auth":"styles_auth__2sbVP","login-txt":"styles_login-txt__mrYp9","signup-txt":"styles_signup-txt__3pGI9"};